export const getEmploymentDetailsAction = (state = {}, action) => {
  switch (action.type) {
    case "GET_EMPLOYMENT_DETAILS":
      return action.data;

    default:
      return state;
  }
};
